import { Button } from '@hub/shared'

export default ({ children, onClick }: any) => {
  return (
    <Button width="100%" onClick={onClick}>
      {children}
    </Button>
  )
}
